import { useMemo } from "react";
import type { ModuleUi } from "@vixio/data";
import { activeModules } from "./registry";
import { useModuleState } from "./SessionGate";

export function useActiveModules(): ModuleUi[] {
  const state = useModuleState();
  return useMemo(() => activeModules(state), [state]);
}
